import { DNode } from '@dojo/framework/core/interfaces';
import { create, v, w } from '@dojo/framework/core/vdom';
import { Icon } from '@holmescorp/base-widgets';
import { TrackedState } from '@holmescorp/lcc-interfaces';
import { userstate, createNlsMiddleware } from '@holmescorp/lcc-state';
import { isEmpty } from 'lodash-es';

export interface TrackedStatePlus extends TrackedState {
	// :: TrackedState
	// pointscorrect: number;
	// pointsincorrect: number;
	// percent: number;
	// complete: number;
	// total: number;
	// readtime: number;
	percentStr: string;
	reading: string;
	quizPassed: boolean;
	quizFail: boolean;
	quizStarted: boolean;
	quizScore: DNode | string;
	readingComplete: boolean;
	failIcon: DNode;
}

export interface StatusAPI {
	data(key: string): TrackedStatePlus;
}

export interface PercentSet {
	pct: number;
	pctStr: string;
}

export interface ReadingSet {
	complete: number;
	total: number;
	ratio: string;
}

const factory = create({
	userstate,
	nls: createNlsMiddleware('ditabook')
});

export const status = factory(({ middleware: { userstate, nls } }) => {
	const { format } = nls();

	const pass_threshold = 80;
	let quizScore: string | DNode = '...';
	let reading = '...';

	let contentPlus: TrackedStatePlus = { quizScore, reading } as TrackedStatePlus;

	const api: StatusAPI = {
		data(this: StatusAPI, key: string): TrackedStatePlus {
			const { get, path } = userstate;
			const state = get(path('status'));
			let content = {} as TrackedState;
			if (!isEmpty(state)) {
				const status = state[key];
				content = status.data;

				const { complete, total } = content;

				const readingComplete = complete === total;

				const percent = (): PercentSet => {
					const { percent } = content;
					const pct = Math.round(percent * 100);
					const pctStr = `${pct}%`;
					return { pct, pctStr };
				};

				const passed = (): boolean => {
					const { pct } = percent();
					return pct > pass_threshold;
				};

				const { pct, pctStr: percentStr } = percent();
				const quizPassed = passed();
				const quizFail = !quizPassed;
				const quizStarted = (quizPassed || quizFail) && pct > 0;
				const failIcon = v('span', { style: 'color: red' }, [w(Icon, { faname: 'exclamation-circle' })]);
				quizScore =
					quizStarted && quizFail
						? v('span', {}, [v('span', {}, [percentStr]), failIcon])
						: quizStarted && quizPassed
						? percentStr
						: '...';

				reading = complete > 0 ? format('complete_of_total', { complete, total }) : '...';
				contentPlus = Object.assign(
					{
						percentStr,
						reading,
						quizScore,
						quizPassed,
						quizFail,
						quizStarted,
						readingComplete,
						failIcon
					},
					content
				);
			}
			return contentPlus;
		}
	};

	return api;
});
